import { c as createCommonjsModule } from './_commonjsHelpers-64249c85.js';
import { i as interopRequireDefault } from './interopRequireDefault-6e0c2256.js';
import { o as objectSpread2 } from './objectSpread2-c7bbc689.js';

var omit_1 = createCommonjsModule(function (module, exports) {

var _interopRequireDefault = interopRequireDefault.default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = omit;
var _objectSpread2 = _interopRequireDefault(objectSpread2);
function omit(obj, fields) {
  var clone = (0, _objectSpread2.default)({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach(function (key) {
      delete clone[key];
    });
  }
  return clone;
}
});

export { omit_1 as o };
